import { toast } from "react-toastify"

import { IResponse } from "constants/interfaces"

import useApi from "util/api"

import { MaintenanceSchedule, MaintenanceSchedulePayload, MaintenanceStatus } from "./type"

const MAINTENANCE_ENDPOINTS = {
  STATUS: "/admin/maintenance",
  SCHEDULE: "/admin/maintenance/schedule",
  ACTIVATE: "/admin/maintenance/activate",
  DEACTIVATE: "/admin/maintenance/deactivate"
}

class MaintenanceService {
  public async getStatus(): Promise<MaintenanceStatus | null> {
    try {
      const { data } = await useApi.get<IResponse<MaintenanceStatus>>(MAINTENANCE_ENDPOINTS.STATUS)
      if (data.success) return data.response ?? null
      return null
    } catch (error) {
      console.error("Maintenance API error:", error)
      toast.error("Failed to load maintenance status")
      return null
    }
  }

  public async updateSchedule(payload: MaintenanceSchedulePayload): Promise<MaintenanceSchedule | null> {
    try {
      const { data } = await useApi.put<IResponse<MaintenanceSchedule>>(MAINTENANCE_ENDPOINTS.SCHEDULE, payload)
      if (data.success) {
        toast.success("Maintenance schedule updated")
        return data.response ?? null
      }
      return null
    } catch (error: any) {
      const message = error?.response?.data?.message || "Failed to update maintenance schedule"
      toast.error(message)
      return null
    }
  }

  public async deleteSchedule(): Promise<boolean> {
    try {
      const { data } = await useApi.delete<IResponse<{ success: boolean }>>(MAINTENANCE_ENDPOINTS.SCHEDULE)
      if (data.success) {
        toast.success("Maintenance schedule deleted")
        return true
      }
      return false
    } catch {
      toast.error("Failed to delete maintenance schedule")
      return false
    }
  }

  public async activate(): Promise<boolean> {
    try {
      const { data } = await useApi.post<IResponse<{ success: boolean }>>(MAINTENANCE_ENDPOINTS.ACTIVATE)
      if (data.success) {
        toast.success("Maintenance mode activated")
        return true
      }
      return false
    } catch {
      toast.error("Failed to activate maintenance mode")
      return false
    }
  }

  public async deactivate(): Promise<boolean> {
    try {
      const { data } = await useApi.post<IResponse<{ success: boolean }>>(MAINTENANCE_ENDPOINTS.DEACTIVATE)
      if (data.success) {
        toast.success("Maintenance mode deactivated")
        return true
      }
      return false
    } catch {
      toast.error("Failed to deactivate maintenance mode")
      return false
    }
  }
}

export const maintenanceService = new MaintenanceService()
